import React from 'react';
import { push as Push } from 'redux-first-history';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { safelyEncodeBase64Url } from '@dev/ee-tools';
import styled from 'styled-components';
import { SecondaryButton, WebsitePrimaryButton } from '@dev/ee-components';
import { CampaignType } from '@dev/ee-api/ee-api-models';

import { CampaignsPaths } from '@/services/dictionaries/Paths';

const ButtonsWrapper = styled.div`
    display: flex;
    margin-top: 32px;

    button {
        margin-right: 10px;
        margin-left: 10px;
    }
`;

export const Buttons = (props: {
    campaignType: CampaignType;
    campaignName: string;
    isScheduled: boolean;
}): JSX.Element => {
    const { campaignType, campaignName, isScheduled } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const clickLeaveBtn = () => {
        if (campaignType === CampaignType.Automated) {
            dispatch(Push(CampaignsPaths.AutorespondersTab));
        } else {
            dispatch(Push(CampaignsPaths.CampaignsTab));
        }
    };
    const clickInProgressBtn = () => {
        dispatch(
            Push(
                CampaignsPaths.CampaignReportInProgress.replace(':type', CampaignType.SendNow).replace(
                    ':name',
                    safelyEncodeBase64Url(campaignName)
                )
            )
        );
    };
    const clickViewReportBtn = () => {
        dispatch(
            Push(
                CampaignsPaths.CampaignAbResults.replace(':type', CampaignType.AbSplit).replace(
                    ':name',
                    safelyEncodeBase64Url(campaignName)
                )
            )
        );
    };

    return (
        <ButtonsWrapper>
            {campaignType === CampaignType.SendNow && !isScheduled && (
                <WebsitePrimaryButton text={t('checksendingprogress')} onClick={clickInProgressBtn} />
            )}
            {campaignType === CampaignType.AbSplit && !isScheduled && (
                <WebsitePrimaryButton text={t('viewreport')} onClick={clickViewReportBtn} />
            )}
            <SecondaryButton text={t('leavecreator')} onClick={clickLeaveBtn} />
        </ButtonsWrapper>
    );
};
